/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpToDottedLine: {
  name: 'arrow-up-to-dotted-line';
  data: string;
} = {
  name: 'arrow-up-to-dotted-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4 14a.5.5 0 0 0 .5-.5V6.207l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 6.207V15a.5.5 0 0 0 .5.5ZM6.5 2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm3.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></svg>`,
};
